const BASIC = (state, payload) => {
  state[payload.key] = payload.value
}

const SET_DEFAULT = (state, payload) => {
  Object.keys(payload).forEach(k => (state[k] = payload[k]))
}

const SET_USER = (state, payload) => {
  state.userFirstName = payload.userFirstName
  state.userLastName = payload.userLastName
  state.userId = payload.userId
  localStorage.setItem('userId', payload.userId)
  state.parentRef = payload.parentRef
  localStorage.setItem('parentRef', payload.parentRef)
  state.userAvatar = payload.avatar
  localStorage.setItem('avatar', payload.avatar)
  state.subscription = payload.subscription
  localStorage.setItem('subscription', payload.subscription)
  state.expirationDate = payload.expirationDate
  localStorage.setItem('expirationDate', payload.expirationDate)
  state.userEmail = payload.email
  localStorage.setItem('userEmail', payload.email)
  if (payload.locale) {
    state.locale = payload.locale
    localStorage.setItem('locale', payload.locale)
  }

  state.rol = payload.rol
  localStorage.setItem('rol', payload.rol)
}

const UNSET_USER = state => {
  state.userName = null
  state.userId = null
  state.parentRef = null
  localStorage.setItem('userId', '')
  localStorage.setItem('parentRef', process.env.VUE_APP_PARENT_REF)
  state.userAvatar = null
  localStorage.setItem('avatar', '')
  state.userEmail = null
  localStorage.setItem('userEmail', '')
  state.rol = null
  localStorage.setItem('rol', '')
}

const LOADED_PERSONAL_DETAILS = (state, payload) => {
  state.personalDetails = payload
}

const SET_MY_DETAILS = (state, payload) => {
  state.userFirstName = payload.userFirstName
  state.userLastName = payload.userLastName
  state.companyName = payload.companyName || ''
  state.jobPosition = payload.jobPosition
  state.city = payload.city
  state.country = payload.country
}

const CHANGE_LOCALE = (state, payload) => {
  localStorage.setItem('locale', payload)
  state.locale = payload
}

const CHANGE_ROL = (state, payload) => {
  state.rol = payload
}

const CHANGE_AVATAR = (state, payload) => {
  state.userAvatar = payload
}

const USER = (state, payload) => {
  if (payload.name || payload.name === null) state.userName = payload.name
  if (payload.avatar && state.userAvatar === null)
    state.userAvatar = payload.avatar
  if (payload.email || payload.email === null) state.userEmail = payload.email
}

export default {
  BASIC,
  SET_USER,
  SET_DEFAULT,
  UNSET_USER,
  LOADED_PERSONAL_DETAILS,
  SET_MY_DETAILS,
  CHANGE_LOCALE,
  CHANGE_ROL,
  CHANGE_AVATAR,
  USER
}
